export const URL_PATHS = {
  PROBLEM1: "/Problem1",
  HOME: "/",
  PROBLEM2: "/Problem2",
  PROBLEM3: "/Problem3",
  PROBLEM4: "/Problem4",
  PROBLEM5: "/Problem5",
  PROBLEM6: "/Problem6",
  PROBLEM7: "/Problem7",
};
